import { useState } from 'react';

import AutocompleteAddress from '../../models/AutocompleteAddress';

type SearchProps = AutocompleteAddress & {
  isRecent: boolean;
  unit: string;
};

// NOTE: this might need to be store in localStorage
export const useGetSearch = () => {
  const [data, setData] = useState<Array<SearchProps>>([]);

  const addRecentSearch = (recentSearch: SearchProps) => {
    const prevSearchState = structuredClone(data);

    let isUnique = true;

    prevSearchState.forEach((search) => {
      if (search.name === recentSearch.name) {
        isUnique = false;
      }
    });

    if (!isUnique) {
      return;
    }

    setData([
      ...prevSearchState,
      {
        ...new AutocompleteAddress(recentSearch),
        isRecent: Boolean(recentSearch.isRecent),
        unit: String(recentSearch.unit),
      },
    ]);
  };

  return { data, addRecentSearch };
};
